const localStorage = window.localStorage
// const SESSION_KEY = 'JSESSIONTOKEN'
const TEMP_HREF = 'TEMP_HREF'
export default {
  /**
   * temp href 基本方法
   */
  getTempHref () {
    return this.getItem(TEMP_HREF)
  },
  getOnceTempHref () {
    let result = this.getTempHref()
    if (!result) {
      return null
    }
    this.clsTempHref()
    return result
  },
  setTempHref (data, callback) {
    let result = this.setItem(TEMP_HREF, data)
    if (typeof callback === 'function') {
      callback()
    }
    return result
  },
  clsTempHref () {
    return this.removeItem(TEMP_HREF)
  },
  // /**
  //  * session 基本方法
  //  */
  // getSession () {
  //   return this.getItem(SESSION_KEY)
  // },
  // setSession (session, callback) {
  //   let result = this.setItem(SESSION_KEY, session)
  //   if (typeof callback === 'function') {
  //     callback()
  //   }
  //   return result
  // },
  // clsSession () {
  //   return this.removeItem(SESSION_KEY)
  // },
  /**
   * 以下为内部基本方法
   */
  setItem (key, data) {
    return localStorage.setItem(key, data)
  },
  getItem (key) {
    return localStorage.getItem(key)
  },
  removeItem (key) {
    return localStorage.removeItem(key)
  },
  clear () {
    return localStorage.clear()
  }
}



// WEBPACK FOOTER //
// ./src/core/storage.js